import SliceNames from '@/state/enum';
import { SecondaryNavState } from '@/state/slices/secondary-nav/typings';

const scriptElement = document.querySelector('#secondary_nav_json');
let secondaryNavParsedState: SecondaryNavState[SliceNames.SECONDARY_NAV] = {};
if (scriptElement) {
	try {
		secondaryNavParsedState = JSON.parse(
			scriptElement.innerHTML,
		) as SecondaryNavState[SliceNames.SECONDARY_NAV];
	} catch {}
}

const secondaryNavState: SecondaryNavState = {
	[SliceNames.SECONDARY_NAV]: secondaryNavParsedState,
};

export default secondaryNavState;
